import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MaskInput = _resolveComponent("MaskInput")!
  const _component_Error = _resolveComponent("Error")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
            'input-wrapper',
            'input-wrapper--field',
            'input-wrapper--' + _ctx.type,
            'input-wrapper--' + _ctx.name,
        ]),
    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('click')))
  }, [
    _createElementVNode("label", {
      class: _normalizeClass([_ctx.hasError ? 'has-error' : '', _ctx.isValid ? 'valid' : ''])
    }, [
      _createVNode(_component_MaskInput, {
        type: _ctx.type,
        name: _ctx.name,
        disabled: _ctx.disabled,
        value: _ctx.model,
        mask: _ctx.modelPattern,
        placeholder: _ctx.placeholder,
        inputmode: _ctx.isNumeric ? 'decimal' : 'text',
        onInput: _ctx.onInput,
        onBlur: _cache[0] || (_cache[0] = ($event: any) => (_ctx.validate())),
        onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('keyup')))
      }, null, 8, ["type", "name", "disabled", "value", "mask", "placeholder", "inputmode", "onInput"]),
      _createElementVNode("div", {
        class: _normalizeClass([
                    _ctx.model?.length ? 'not-empty' : '',
                    'input__label',
                    'input__label--' + _ctx.name,
                    'input__label--' + _ctx.type,
                ])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ], 2),
    (_ctx.handlesError)
      ? (_openBlock(), _createBlock(_component_Error, {
          key: 0,
          name: _ctx.name
        }, null, 8, ["name"]))
      : _createCommentVNode("", true)
  ], 2))
}